import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "contact-section",
  id: "contact"
}
const _hoisted_2 = { class: "section-shell contact-shell reveal" }
const _hoisted_3 = { class: "contact-copy" }
const _hoisted_4 = { class: "contact-details" }
const _hoisted_5 = { href: "tel:+496111234567" }
const _hoisted_6 = { href: "mailto:projekt@freiraum-galabau.de" }
const _hoisted_7 = { type: "submit" }

import { ArrowRight, Mail, MapPin, Phone } from "lucide-vue-next";
import "@/assets/styles/contact.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "eyebrow light" }, "Ihr Projekt beginnt hier", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, [
          _createTextVNode("Was können wir für Sie "),
          _createElementVNode("em", null, "wachsen lassen?")
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, "Erzählen Sie uns kurz von Ihrem Vorhaben. Wir melden uns persönlich und sprechen über den sinnvollsten nächsten Schritt.", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(Phone)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, [
              _createElementVNode("small", null, "Direkt anrufen"),
              _createTextVNode("+49 611 123 45 67")
            ], -1))
          ]),
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_unref(Mail)),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, [
              _createElementVNode("small", null, "E-Mail schreiben"),
              _createTextVNode("projekt@freiraum-galabau.de")
            ], -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(MapPin)),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, [
              _createElementVNode("small", null, "Unser Einsatzgebiet"),
              _createTextVNode("Rhein-Main & Umgebung")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("form", {
        class: "contact-form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"form-row\"><label>Name<input type=\"text\" placeholder=\"Wie dürfen wir Sie ansprechen?\"></label><label>Unternehmen<input type=\"text\" placeholder=\"Optional\"></label></div><label>E-Mail<input type=\"email\" placeholder=\"name@unternehmen.de\"></label><label>Worum geht es?<select><option>Neue Außenanlage</option><option>Pflege &amp; Service</option><option>Privatgarten</option><option>Sonstiges Projekt</option></select></label><label>Ihre Nachricht<textarea rows=\"4\" placeholder=\"Ein paar Stichpunkte zu Fläche, Ort und Wunsch ...\"></textarea></label>", 4)),
        _createElementVNode("button", _hoisted_7, [
          _cache[7] || (_cache[7] = _createTextVNode("Unverbindlich anfragen ", -1)),
          _createVNode(_unref(ArrowRight))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("small", { class: "form-note" }, "Wir melden uns in der Regel innerhalb eines Werktags.", -1))
      ], 32)
    ])
  ]))
}
}

})